module.exports = __webpack_public_path__ + "static/media/Chicken6.b51520c9.png";